import Avatar from '@/components/common/Avatar';
import { accessLevelRenderer } from './DomainCard';
import SubtleBadge from '@/components/common/SubtleBadge';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import type { Dispatch, SetStateAction } from 'react';
import type { DomainMemberUser } from './types';

type MembersColumn = ColDef<DomainMemberUser> & {
  searchable?: boolean;
  type?: string;
};

export const membersColumnConfig = (
  setTriggeredRem: Dispatch<SetStateAction<DomainMemberUser | false>>,
): MembersColumn[] => [
  {
    searchable: true,
    field: 'name',
    type: 'string',
    title: 'نام',
    minWidth: 100,
    suppressHeaderMenuButton: true,
    flex: 1,
    cellRenderer: (params: ICellRendererParams<DomainMemberUser>) => (
      <div className="d-flex justify-content-start gap-1 h-100 align-items-center">
        <Avatar
          src={params.data?.image}
          size="m"
          className="border border-3 rounded-circle border-200"
          name={
            params.data?.name || params.data?.family
              ? `${params.data?.name} ${params.data?.family}`
              : ''
          }
        />
        {params.data?.name}
      </div>
    ),
  },
  {
    searchable: true,
    field: 'family',
    type: 'string',
    title: 'نام‌خانوادگی',
    suppressHeaderMenuButton: true,
    width: 120,
  },
  {
    searchable: true,
    field: 'phone_number',
    type: 'string',
    title: 'شماره‌تلفن',
    suppressHeaderMenuButton: true,
    width: 115,
  },
  {
    searchable: true,
    field: 'access_level',
    suppressHeaderMenuButton: true,
    type: 'number',
    title: 'دسترسی',
    width: 100,
    cellRenderer: (params: ICellRendererParams<DomainMemberUser, number>) => (
      <SubtleBadge
        pill
        bg={accessLevelRenderer(params.value ?? 0).color}
        className="fs--2"
      >
        {accessLevelRenderer(params.value ?? 0).label}
      </SubtleBadge>
    ),
  },
  {
    searchable: false,
    field: 'id',
    type: 'number',
    sortable: false,
    suppressHeaderMenuButton: true,
    title: '',
    width: 60,
    cellRenderer: (params: ICellRendererParams<DomainMemberUser>) =>
      params?.data?.access_level !== 1 && (
        <div className="d-flex justify-content-center gap-1 h-100 align-items-center">
          <Button
            title="حذف کاربر"
            variant="danger"
            onClick={() => {
              if (params.data) setTriggeredRem(params.data);
            }}
            style={{ padding: '6.5px' }}
            className="justify-content-center gap-1 border-300 d-flex align-items-center"
          >
            <FontAwesomeIcon icon="user-xmark" size="sm" />
          </Button>
        </div>
      ),
  },
];
